import Box from '@rsos/base-components/Box';
import { ChatNotifications } from './ChatNofications';

interface Props {
  callerID: string;
}

export function HeaderNotifications({ callerID }: Props) {
  return (
    <Box marginTop={2}>
      {/* There will be more types of notifications here */}
      <ChatNotifications callerID={callerID} />
    </Box>
  );
}
